import React from "react";

export default function Web_W3CSS() {
  return (
    <div>
      <h1>What is W3.CSS</h1>
      <p>
        Route: <code>/web/w3css</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
